// extracted by mini-css-extract-plugin
export default {"cardBody":"card-body_cardBody__evHiE","container":"card-body_container__1QcT5","containerEllipsis":"card-body_containerEllipsis__ausSM"};